// 写真のパララックス: <img data-mp-parallax="24">
// 親要素が画面内にある間、スクロール位置に応じて上下に動かす（値は 1440px 幅での振れ幅 px）。
// reduced-motion のときは何もしない。

import { reduceMotion } from './reveal.js';

export function setupParallax() {
  const images = [...document.querySelectorAll('[data-mp-parallax]')];
  if (images.length === 0 || reduceMotion) return;

  const update = () => {
    const viewportHeight = window.innerHeight || 1;
    const unit = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mp-s')) || 1;
    images.forEach((img) => {
      const rect = img.parentElement.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) return;
      const amplitude = parseFloat(img.dataset.mpParallax) || 24;
      const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
      const y = (0.5 - Math.min(1, Math.max(0, progress))) * 2 * amplitude * unit;
      img.style.transform = `scale(1.18) translateY(${y.toFixed(2)}px)`;
    });
  };

  let ticking = false;
  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          update();
          ticking = false;
        });
      }
    },
    { passive: true },
  );
  update();
}
